(() => {
  'use strict';
  if (customElements.get('gnd-offer')) return;
  class DefinitiveOffer extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const on = (el, type, fn, options={}) => el?.addEventListener(type, fn, {...options, signal:this.abort.signal});
      this.radios = [...this.querySelectorAll('[data-bundle]')];
      this.gifts = [...this.querySelectorAll('[data-gift]')];
      this.details = this.querySelector('.gnd-dialog');
      const formatter = new Intl.NumberFormat('en-US',{style:'currency',currency:this.dataset.moneyCurrency || 'USD',minimumFractionDigits:0,maximumFractionDigits:2});
      this.money = cents => formatter.format(Number(cents)/100);
      this.radios.forEach(radio => on(radio,'change',()=>this.updateGifts(true)));
      this.querySelectorAll('[data-details]').forEach(button => on(button,'click',()=>this.openDetails(button)));
      this.querySelectorAll('[data-close-details]').forEach(button=>on(button,'click',()=>this.details.close()));
      for (const dialog of [this.details]) {
        on(dialog,'click',event=>{
          if (event.target !== dialog) return;
          const box=dialog.getBoundingClientRect();
          if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) dialog.close();
        });
        on(dialog,'close',()=>{this.opener?.focus({preventScroll:true}); document.documentElement.classList.remove('gnd-dialog-open');});
      }
      this.products = JSON.parse(this.querySelector('[data-gnd-products]').textContent);
      this.unavailableLabel = this.querySelector('.gnd-cart-status').textContent;
      on(this.querySelector('[data-gnd-add]'),'click',()=>this.addBundle());
      on(document,'shopify:block:select',event=>{
        const radio=event.target.querySelector('[data-bundle]');
        if(radio&&this.contains(radio)){radio.checked=true;this.updateGifts(false);}
      });
      on(window,'pageshow',event=>{if(!event.persisted)return;this.removeAttribute('data-checkout-state');this.adding=false;const button=this.querySelector('[data-gnd-add]');button.disabled=false;button.removeAttribute('aria-busy');button.textContent=this.atcLabel;this.radios.forEach(radio=>radio.disabled=false);});
      this.atcLabel=this.querySelector('[data-gnd-add]').textContent;
      this.radios.forEach(radio=>this.updatePrices(radio));
      this.updateGifts(false);
    }
    async addBundle(){
      if(this.adding)return;
      const button=this.querySelector('[data-gnd-add]');
      const status=this.querySelector('.gnd-cart-status');
      const label=button.textContent;
      const unavailable=this.unavailableLabel;
      this.adding=true;button.disabled=true;button.setAttribute('aria-busy','true');
      status.hidden=true;button.textContent=button.dataset.addingLabel||'ADDING…';
      this.radios.forEach(radio=>radio.disabled=true);
      try{
        const radio=this.selected();
        const group='gnd-'+(crypto.randomUUID?crypto.randomUUID():Date.now()+'-'+Math.random().toString(36).slice(2));
        const bundle={key:radio.dataset.bundleKey,title:radio.dataset.title,contents:radio.dataset.contents,images:[...radio.closest('label').querySelectorAll('.gnd-packshots img')].map(image=>image.src).slice(0,3)};
        const eligible=this.gifts.filter(gift=>Number(gift.dataset.level)<=Number(radio.dataset.level)).map(gift=>({kind:gift.dataset.cartGift,key:gift.dataset.giftKey}));
        const api=window.GndBundleCart;
        if(!api)throw new Error(button.dataset.errorLabel);
        if(!this.products[bundle.key])throw new Error(unavailable);
        let oldPlan;
        try{oldPlan=api.planFor(this.products[bundle.key]);}catch(_){}
        // Refresh only when buying. Published products/plans may change while a tab stays open.
        this.products[bundle.key]=await api.refreshProduct(this.products[bundle.key]);
        const currentPlan=api.planFor(this.products[bundle.key]);
        this.updatePrices(radio);
        if(this.dataset.productPrices==='true'&&oldPlan&&
          (Number(oldPlan.price)!==Number(currentPlan.price)||Number(this.refillPrice(oldPlan))!==Number(this.refillPrice(currentPlan)))){
          throw new Error('The subscription price has changed. Review the updated prices and tap Add to Cart again.');
        }
        const items=api.buildItems(this.products,bundle,group,eligible);
        await api.add(items,group,button);
      }catch(error){
        this.removeAttribute('data-checkout-state');
        status.textContent=error.message||button.dataset.errorLabel;status.hidden=false;
      }finally{
        if(this.dataset.checkoutState!=='confirmed'){this.adding=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=label;this.radios.forEach(radio=>radio.disabled=false);}
      }
    }
    refillPrice(plan){return plan.prices?.[plan.prices.length-1]?.price ?? plan.price;}
    updatePrices(radio){
      if(this.dataset.productPrices!=='true')return;
      let plan;
      try{plan=window.GndBundleCart?.planFor(this.products[radio.dataset.bundleKey]);}catch(_){return;}
      if(!plan||typeof plan.price!=='number'||!Number.isFinite(plan.price))return;
      const price=Number(plan.price),compare=Number(radio.dataset.compare);
      const priceBox=radio.closest('label').querySelector('.gnd-price');
      priceBox.querySelector('strong').textContent=this.money(price);
      const showCompare=this.dataset.moneyCurrency===this.dataset.shopCurrency&&compare>price;
      priceBox.querySelector('del').hidden=!showCompare;
      const saving=radio.closest('label').querySelector('.gnd-saving');
      if(saving)saving.hidden=!showCompare;
      if(showCompare){priceBox.querySelector('del').textContent=this.money(compare);if(saving)saving.textContent='Save '+this.money(compare-price);}
      radio.dataset.price=String(price);
      const details=this.querySelector(`[id="BundleDetails-${radio.value}"]`)?.content;
      if(details){
        details.querySelector('[data-first-price]').textContent=this.money(price);
        details.querySelector('[data-refill-price]').textContent=this.money(this.refillPrice(plan))+' · '+plan.name;
        const total=details.querySelector('[data-first-total]');
        if(total){total.hidden=this.dataset.moneyCurrency!==this.dataset.shopCurrency;total.textContent=this.money(price+Number(radio.dataset.shipping))+' total before tax';}
      }
      (this.closest('.shopify-section')||this).querySelectorAll('[data-gnd-faq-price]').forEach(el=>{
        if(el.dataset.gndFaqPrice===radio.dataset.bundleKey)el.textContent=this.money(price);
      });
    }
    selected(){return this.radios.find(radio=>radio.checked)||this.radios[0];}
    updateGifts(animate){
      this.querySelector('.gnd-cart-status').hidden=true;
      this.radios.forEach(radio=>{const panel=radio.closest('.bv-card')?.querySelector('[data-bundle-panel]');if(panel)panel.hidden=!radio.checked;});
      const level=Number(this.selected()?.dataset.level||0);let count=0;
      this.gifts.forEach(gift=>{
        const wasLocked=gift.classList.contains('is-locked');
        const locked=Number(gift.dataset.level)>level;
        gift.classList.toggle('is-locked',locked);
        gift.querySelector('[data-gift-locked]').hidden=!locked;
        gift.querySelector('[data-gift-unlocked]').hidden=locked;
        gift.setAttribute('aria-label',`${gift.dataset.name} — ${locked?gift.dataset.unlock:'Included in your bundle'}. View details.`);
        if(!locked)count++;
        if(animate&&wasLocked&&!locked)this.celebrate(gift);
      });
      const counter=this.querySelector('[data-gift-count]');
      if(counter)counter.textContent=`${count}/${this.gifts.length} ${this.dataset.unlockedLabel}`;
    }
    celebrate(gift){
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const tile=gift.querySelector('.gnd-gift-tile');
      tile.animate([{transform:'scale(1)'},{transform:'scale(1.07)',offset:.35},{transform:'scale(1)'}],{duration:450});
      for(let i=0;i<14;i++){
        const bit=document.createElement('i');bit.className='gnd-confetti';
        bit.style.background=['#8a1b42','#e7b2c6','#c9a56e'][i%3];tile.append(bit);
        const x=(Math.random()-.5)*110,y=-35-Math.random()*45;
        const animation=bit.animate([{transform:'translate(0,0)',opacity:0},{transform:`translate(${x*.5}px,${y}px) rotate(120deg)`,opacity:1,offset:.45},{transform:`translate(${x}px,25px) rotate(280deg)`,opacity:0}],{duration:850+Math.random()*250});
        animation.finished.then(()=>bit.remove()).catch(()=>bit.remove());
      }
    }
    openDetails(button){
      const template=this.querySelector(`[id="${button.dataset.details}"]`);
      if(!template)return;
      this.opener=button;
      const body=this.details.querySelector('[data-details-body]');
      body.replaceChildren(template.content.cloneNode(true));
      body.querySelector('[data-dialog-title]').id=this.details.getAttribute('aria-labelledby');
      const status=body.querySelector('[data-gift-status]');
      if(status)status.textContent=button.classList.contains('is-locked')?button.dataset.unlock:'Included in your bundle';
      this.details.showModal();document.documentElement.classList.add('gnd-dialog-open');
    }
    disconnectedCallback(){
      this.details?.close();this.abort?.abort();this.abort=null;
      document.documentElement.classList.remove('gnd-dialog-open');
    }
  }
  customElements.define('gnd-offer',DefinitiveOffer);
})();
